import { render, staticRenderFns } from "./landline-phone.vue?vue&type=template&id=8c079e70"
import script from "./landline-phone.vue?vue&type=script&lang=js"
export * from "./landline-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports